import { Env } from './env';

export const defaultEnv: Partial<Env> = {
  DEPLOYMENT_MODE: 'saas',
  SHOW_TANSTACK_DEVTOOLS: 'false',
};

export const withDefaults = (env: Partial<Env>): Env => {
  return { ...defaultEnv, ...env } as Env;
};
